import axios from "axios";
import config from "../../config/config";
import { getToken } from "../../common";

// live status of an auction's bidders: { userId: { state, at, ip, lastBidAt } }
const eventBuyersPresenceAPI = async (eventId) =>
  axios({
    method: "get",
    url: `${config.api.base_url}dashboard/events/${eventId}/buyers-presence`,
    headers: { Authorization: getToken() },
  });

export default eventBuyersPresenceAPI;
